import type { PostGeoConfig } from 'pages/Settings/GeoConfigSettings/api/useGeoConfig/useGeoConfig';

export const defaultProfile: PostGeoConfig = {
  configId: 0,
  name: '',
  locations: [
    {
      name: 'Pin 1',
      latitude: 0,
      longitude: 0,
      radius: 30,
    },
  ],
};
